var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { View } from "react-native";
import GraphicsTypes from "./Graphic";
import Example from "./example";
import FrecuencyTable from "./FrequencyTable";
import Controls from "./Controls";
export { Example };
var SCharts = /** @class */ (function (_super) {
    __extends(SCharts, _super);
    function SCharts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            viewBox: { width: 0, height: 0, x: 0, y: 0 },
            showValue: _this.props.showValue,
            showGuide: _this.props.showGuide,
            showLabel: _this.props.showLabel
        };
        _this.onLayoutHandle = function (e) {
            var _a = e.nativeEvent.layout, width = _a.width, height = _a.height, x = _a.x, y = _a.y;
            _this.setState({ viewBox: { width: width, height: height, x: x, y: y } });
        };
        return _this;
    }
    SCharts.prototype.render = function () {
        var _a = this.props, type = _a.type, data = _a.data, colors = _a.colors;
        var table = new FrecuencyTable(data);
        if (colors) {
            table.intervals_color = colors;
        }
        var GRAPHIC_TYPE_CLASS = GraphicsTypes[type !== null && type !== void 0 ? type : "Barras"];
        return React.createElement(View, { style: __assign({ width: "100%", flex: 1 }, this.props.style), onLayout: this.onLayoutHandle.bind(this) },
            React.createElement(GRAPHIC_TYPE_CLASS, __assign({ frecuencyTable: table }, this.props, this.state)),
            !this.props.showControl ? null : React.createElement(Controls, { parent: this }));
    };
    return SCharts;
}(React.Component));
export default SCharts;
;
